import { createPopper } from '../../assets/vendor/@popperjs/core/lib/popper-lite.js';
import preventOverflow from '../../assets/vendor/@popperjs/core/lib/modifiers/preventOverflow.js';
import flip from '../../assets/vendor/@popperjs/core/lib/modifiers/flip.js';
import offset from '../../assets/vendor/@popperjs/core/lib/modifiers/offset.js';
import arrow from '../../assets/vendor/@popperjs/core/lib/modifiers/arrow.js';
import computeStyles from '../../assets/vendor/@popperjs/core/lib/modifiers/computeStyles.js';

Vue.asyncComponent('ak-tooltip', {
    data() {
        return {
            persistentOpen: true,
            hover: false,
            popperInstance: null,
        }
    },
    props: {
        body: {
            type: String,
        },
        position: {
            type: String,
            default: 'top',
        },
        disabled: {
            type: Boolean,
        },
        persistent: {
            type: Boolean,
        },
        hidden: {
            type: Boolean,
            default: true,
        },
        absolute: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        disabled() {
            this.resetPosition();
            this.$nextTick(this.mouseEnter);
        }
    },
    methods: {
        mouseEnter() {
            if (this.disabled){
                return;
            }

            // Enable the event listeners
            this.popperInstance.setOptions((options) => ({
                ...options,
                modifiers: [
                    ...options.modifiers,
                    { name: 'eventListeners', enabled: true },
                ],
            }));

            // Update its position
            this.popperInstance.update();

            this.hover = true;
        },
        mouseLeave() {
            if (this.disabled){
                return;
            }

            // Disable the event listeners
            this.popperInstance.setOptions((options) => ({
                ...options,
                modifiers: [
                    ...options.modifiers,
                    { name: 'eventListeners', enabled: false },
                ],
            }));

            this.hover = false;
        },
        close() {
            this.persistentOpen = false;
        },
    },
    mounted() {
        const options =  {
            modifiers: [ offset,{
                name: 'offset',
                options: {
                    offset: [0, 10],
                },
            }, preventOverflow, flip, arrow, computeStyles],
            strategy: 'fixed',
        };

        if (this.position) {
            options.placement = this.position;
        }

        this.popperInstance = createPopper(this.$refs.wrapper, this.$refs.tooltip, options);
    },
    beforeDestroy() {
        this.popperInstance.destroy();
    }
}, 'layout/ak-tooltip.html');